import { Typography } from '@mui/material';
import styled from 'styled-components';

export const ProblemTkdHeaderText = styled(Typography)`
  max-width: 80px;
  font-size: inherit;
`;
